import PropTypes from "prop-types";
import React from "react";
import Rail from "web/react/components/rail/rail";
import RelatedDesignerImage from "./related-designer-image";
import styles from "./related-designers-rail.css";

function RelatedDesignersRail({ title, relatedDesigners }) {
    return (
        <div className={styles.railWrapper}>
            <Rail title={title} analyticsLabel="related_designers" className={styles.rail}>
                {relatedDesigners.map((relatedDesigner) => {
                    return (
                        <div key={relatedDesigner.designer_url}>
                            <RelatedDesignerImage designer={relatedDesigner} />
                        </div>
                    );
                })}
            </Rail>
        </div>
    );
}

RelatedDesignersRail.propTypes = {
    title: PropTypes.string,
    relatedDesigners: PropTypes.array.isRequired,
};

export default RelatedDesignersRail;
